import { Component, Input } from '@angular/core';
import { stagger40ms } from '../../../../../@vex/animations/stagger.animation';
import { TimelineAvatar, TimelineEntry } from '../../interfaces/timeline.interface';

/**
 * Timeline unifiée « Historique des statuts » (rail vertical : pastilles + trait de liaison).
 * Composant PUREMENT présentationnel : aucune donnée n'est chargée ici. Chaque page projette
 * sa forme métier sur `TimelineEntry[]` (via `timeline.util` pour les modules plats, ou un
 * mappeur local pour les modules divergents comme la facture) puis la passe en `entries`.
 *
 * La notion « En charge » (bandeau responsable + avatar par événement) est propre à la facture :
 * elle est désactivée par défaut et n'apparaît que si `showOwner` / `entry.inChargeTracked`.
 */
@Component({
  selector: 'base-timeline',
  templateUrl: './base-timeline.component.html',
  styles: [':host { display: block; }'],
  animations: [stagger40ms],
})
export class BaseTimelineComponent {
  /** Événements déjà normalisés et prêts à afficher (ordre d'affichage respecté, pas de tri ici). */
  @Input() entries: TimelineEntry[] = [];
  /** Titre de la carte. */
  @Input() title = 'Historique des statuts';
  /** Rend `entry.description` en HTML (ex. corps Quill) au lieu d'une interpolation échappée. */
  @Input() descriptionAsHtml = false;
  /** Affiche le bandeau responsable « En charge » (facture uniquement). */
  @Input() showOwner = false;
  @Input() showOwnerAvatar = false;
  /** Responsable actuel : avatar → « En charge X » ; null → « Aucune action requise ». */
  @Input() currentOwner?: TimelineAvatar | null;
  @Input() showCurrentOwnerAvatar = false;
  /** Hauteur max optionnelle du rail avant scroll (ex. '30rem'). */
  @Input() maxHeight?: string;
}
